import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugAripiprazole} from "./TextDrugAripiprazole"


export default function Aripiprazole() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      
 
    <ButtonsText onClick={handleOpen} name='Aripiprazole' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Aripiprazole - PGx Recommendation"
        content={ <TextDrugAripiprazole />}

        />

</>
)}